import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { LearningResult } from "../../recommendation.types";

export const requestLearnFromOrders = async (): Promise<LearningResult> => {
  return await instance.post(ApiRoutesRecommendation.Learn);
};
